import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.scss';
import './index.css';
import App from './App';

import TagManager from 'react-gtm-module';

// Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-PB3RPKRH',
  dataLayerName: 'PageDataLayer'
}

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);